import axios, { AxiosError, AxiosResponse } from 'axios'
import { IDefaultResponse } from '../../models/auth.model'
import { logOutApp, store } from 'src/app/store'
import { SERVER_STATUS_CODES } from '../../constants/serverResponseStatusCodes.constants'
import { SYSTEM_ROLES } from '../../models/common.model'
import { handleGetAccessToken, handleTokenExpired } from '../Network.util'
import { lcStorageUserRole } from '../../constants/localStorage.constants'

const customAxios = (contentType?: string) => {
  const axiosInstance = axios.create({
    headers: {
      'Content-Type': contentType ? contentType : 'application/json',
    },
  })

  axiosInstance.interceptors.request.use(async (request: any) => {
    const newReq = await handleGetAccessToken(request)
    return newReq
  })

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse<any>) => {
      return Promise.resolve(response.data)
    },
    (error: AxiosError<IDefaultResponse<any>>) => {
      if (error?.response) {
        const statusCode = error.response?.status
        if (statusCode && statusCode === 500) {
          alert('500 Internal Server Error')
          return Promise.reject('500 Internal Server Error')
        }

        if (statusCode && statusCode === 401) {
          handleTokenExpired(axiosInstance, error)
          return
        }

        if (statusCode && statusCode === 404) {
          window.location.href = '/page-not-found'
          return
        }

        if (statusCode && statusCode === 403) {
          switch (error.response.data?.statusCode) {
            case SERVER_STATUS_CODES.PPI6_FORCE_RESET_PASSWORD:
              sessionStorage.removeItem('persist:root')
              window.location.href = `/force-reset-password?userName=${error.response.data?.data}`
              break

            case SERVER_STATUS_CODES.PPI3_LOCK_USER:
              sessionStorage.removeItem('persist:root')
              window.location.href = `/locked-user`
              break

            case SERVER_STATUS_CODES.PPI4_USER_IS_INACTIVE:
              sessionStorage.removeItem('persist:root')
              window.location.href = `/inactive-user`
              break

            case SERVER_STATUS_CODES.PPI19_FORBIDDEN:
              window.location.href = `/access-denied`
              break

            case SERVER_STATUS_CODES.PPI18_UPDATE_ROLE_AND_PERMISSION:
              const backUrl = store.getState().auth?.userProfile?.role?.includes(SYSTEM_ROLES.CLIENT_USER)
                ? store.getState().masterSetup?.criticalConfig?.clientLogOutLink
                : ''
              console.log('backUrl: ', backUrl)
              sessionStorage.removeItem('persist:root')
              sessionStorage.removeItem(lcStorageUserRole)
              if (backUrl) {
                setTimeout(() => {
                  window.location.href = backUrl
                }, 200)
              } else {
                store.dispatch(logOutApp())
                return Promise.reject(error)
              }

              break

            default:
              break
          }

          return Promise.reject(error.response.data)
        }
      }
      return Promise.reject(error.response?.data)
    },
  )

  return axiosInstance
}

export default customAxios
